import React, { useEffect } from "react";
import "@/App.css";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import {
  ExperienceSection,
  SkillsSection,
  ProjectsSection,
  ActivitiesSection,
  EducationSection,
  ContactSection,
  Footer,
} from "@/components/PortfolioSections";

function App() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
    );

    const elements = document.querySelectorAll(".animate-fade-up");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    function removeEmergentBadge() {
      const badge = document.getElementById("emergent-badge");
      if (badge) badge.remove();

      document.querySelectorAll("a, div, p, span").forEach((el) => {
        if (el.textContent && el.textContent.includes("Made with Emergent")) {
          el.remove();
        }
      });
    }

    removeEmergentBadge();

    const mo = new MutationObserver(removeEmergentBadge);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0A0A] transition-colors duration-300">
      <Header />
      <main>
        <HeroSection />
        <ExperienceSection />
        <SkillsSection />
        <ProjectsSection />
        <ActivitiesSection />
        <EducationSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
